import axios from 'axios';
import { endpoints } from './endpoints';
import { getAuthToken, sanitizeForServer } from 'utils/helpers';
import { ROLE_TYPES } from './constants';
import { toast } from 'react-toastify';

//Fetch data
export const getRequestData = async (url, domain, onSuccess) => {
  const token = getAuthToken(domain);

  try {
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (onSuccess) {
      onSuccess(response.data);
    }
    return { data: response.data, error: null };
  } catch (error) {
    if (typeof error.response.data === 'string') {
      toast.error(error.response.data);
    }
    toast.error(error.response.data.error);
  }
};

const sanitizeForRequest = (data) => {
  if (typeof FormData !== 'undefined' && data instanceof FormData) return data;
  return sanitizeForServer(data);
};

// Update user image
export const updateUserImage = (userID, image, domain) => {
  const token = getAuthToken(domain);
  const formData = new FormData();
  formData.append('image', image);

  axios
    .post(endpoints.uploadAvatar(userID), formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      console.log(response, 'image upload response');
    })
    .catch((error) => {
      if (typeof error.response.data === 'string') {
        toast.error(error.response.data);
      }
      toast.error(error.response.data.error);
    });
};

// Delete external document
export const deleteDocument = (userID, documentId, domain) => {
  const token = getAuthToken(domain);

  return axios
    .delete(endpoints.deleteDocument(userID, documentId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (typeof error.response.data === 'string') {
        toast.error(error.response.data);
      }
      toast.error(error.response.data.error);
    });
};

// Upload external document
export const uploadDocument = (userID, document, domain) => {
  const token = getAuthToken(domain);
  const formData = new FormData();
  formData.append('doc', document);

  return axios
    .post(endpoints.uploadDocument(userID), formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      console.log(response, 'document upload response');
      return response.data;
    })
    .catch((error) => {
      if (typeof error.response.data === 'string') {
        toast.error(error.response.data);
      }
      toast.error(error.response.data.error);
    });
};

//Create partner
export const createPartner = async (formData, domain, onSuccess) => {
  const token = getAuthToken(domain);
  try {
    const response = await axios.post(endpoints.registerPartner, sanitizeForRequest(formData), {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (onSuccess) {
      onSuccess(response.data);
    }
    return response.data;
  } catch (error) {
    if (typeof error.response.data === 'string') {
      toast.error(error.response.data);
    }
    toast.error(error.response.data.error);
  }
};
//Update partner
export const updatePartner = async (formData, userID, domain, onSuccess) => {
  const token = getAuthToken(domain);
  try {
    const response = await axios.put(
      endpoints.updatePartner(userID),
      sanitizeForRequest(formData),
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      },
    );

    if (onSuccess) {
      onSuccess(response.data);
    }
    return response.data;
  } catch (error) {
    if (typeof error.response.data === 'string') {
      toast.error(error.response.data);
    }
    toast.error(error.response.data.error);
  }
};

//Create client
export const createClient = async (formData, domain, onSuccess) => {
  const token = getAuthToken(domain);

  try {
    const response = await axios.post(endpoints.registerClient, sanitizeForRequest(formData), {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (onSuccess) {
      onSuccess(response.data);
    }
    return response.data;
  } catch (error) {
    if (typeof error.response.data === 'string') {
      toast.error(error.response.data);
    }
    toast.error(error.response.data.error);
  }
};
//Update client
export const updateClient = async (formData, userID, domain, onSuccess) => {
  const token = getAuthToken(domain);

  const data = {
    firstname: formData.profile.firstname,
    lastname: formData.profile.lastname,
    gender: formData.profile.gender,
    phone: formData.profile.phone,
    pronoun: formData.profile.identifyas,
    birthdate: formData.profile.birthdate,
    country_code: formData.profile.country_code,
    partner: {
      moveInDate: formData.profile.moveInDate,
      startDate: formData.profile.startDate,
    },
  };

  try {
    const response = await axios.put(endpoints.updateUser(userID), sanitizeForRequest(data), {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (onSuccess) {
      onSuccess(response.data);
    }
    return response.data;
  } catch (error) {
    if (typeof error.response.data === 'string') {
      toast.error(error.response.data);
    }
    toast.error(error.response.data.error);
  }
};

//Terminate client
export const terminateClient = async (userID, formData, domain, onSuccess) => {
  const token = getAuthToken(domain);
  try {
    const response = await axios.post(
      endpoints.terminateUser(userID),
      sanitizeForRequest(formData),
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      },
    );

    if (onSuccess) {
      onSuccess(response);
    }
    return response.data;
  } catch (error) {
    if (typeof error.response.data === 'string') {
      toast.error(error.response.data);
    }
    toast.error(error.response.data.error);
  }
};
//Submit client feedback
export const clientSubmitFeedback = async (formData, domain, onSuccess) => {
  const token = getAuthToken(domain);
  try {
    const response = await axios.post(
      endpoints.clientSubmitFeedback,
      sanitizeForRequest(formData),
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      },
    );

    if (onSuccess) {
      onSuccess(response.data);
    }
    return response.data;
  } catch (error) {
    if (typeof error.response.data === 'string') {
      toast.error(error.response.data);
    }
    toast.error(error.response.data.error);
  }
};

export const toggleUserNotificationsByAdmin = async (userId, payloadOrEnabled, onSuccess) => {
  const token = getAuthToken(ROLE_TYPES.admin);

  const data =
    payloadOrEnabled && typeof payloadOrEnabled === 'object'
      ? payloadOrEnabled
      : { notifications_enabled: !!payloadOrEnabled };

  try {
    const response = await axios.put(
      endpoints.toggleUserNotificationsByAdmin(userId),
      sanitizeForRequest(data),
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      },
    );

    if (onSuccess) {
      onSuccess(response.data);
    }

    return response.data;
  } catch (error) {
    if (!error.response) return;
    if (typeof error.response.data === 'string') {
      toast.error(error.response.data);
    }
    toast.error(error.response.data.error);
  }
};

export const toggleUserNotificationsByManager = async (
  userId,
  payloadOrEnabled,
  onSuccess,
  onError,
) => {
  const token = getAuthToken(ROLE_TYPES.slh_manager);

  const data =
    payloadOrEnabled && typeof payloadOrEnabled === 'object'
      ? payloadOrEnabled
      : { notifications_enabled: !!payloadOrEnabled };

  try {
    const response = await axios.put(
      endpoints.toggleUserNotificationsByManager(userId),
      sanitizeForRequest(data),
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      },
    );

    if (onSuccess) {
      onSuccess(response.data);
    }

    return response.data;
  } catch (error) {
    if (!error.response) return;
    if (typeof error.response.data === 'string') {
      toast.error(error.response.data);
    }
    toast.error(error.response.data.error);
    if (onError) {
      onError(error);
    }
  }
};

//Submit invoice
export const submitInvoiceByManager = async (invoice_id, onSuccess) => {
  const token = getAuthToken(ROLE_TYPES.slh_manager);

  try {
    const response = await axios.post(endpoints.submitInvoice(invoice_id), sanitizeForRequest({}), {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (onSuccess) {
      onSuccess(response.data);
    }
    return response.data;
  } catch (error) {
    if (typeof error.response.data === 'string') {
      toast.error(error.response.data);
    }
    toast.error(error.response.data.error);
  }
};

//Submit additional payment
export const addAdditionalPaymentsByManager = async (invoice_id, formData, onSuccess) => {
  const token = getAuthToken(ROLE_TYPES.slh_manager);

  try {
    const response = await axios.post(
      endpoints.addAdditionalPayments(invoice_id),
      sanitizeForRequest(formData),
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      },
    );

    if (onSuccess) {
      onSuccess(response.data);
    }
    return response.data;
  } catch (error) {
    if (typeof error.response.data === 'string') {
      toast.error(error.response.data);
    }
    toast.error(error.response.data.error);
  }
};
//Remove additional payment
export const removeAdditionalPaymentsByManager = async (invoice_id, payment_id, onSuccess) => {
  const token = getAuthToken(ROLE_TYPES.slh_manager);

  try {
    const response = await axios.delete(
      endpoints.removeAdditionalPayments(invoice_id, payment_id),
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      },
    );

    if (onSuccess) {
      onSuccess(response);
    }
  } catch (error) {
    if (typeof error.response.data === 'string') {
      toast.error(error.response.data);
    }
    toast.error(error.response.data.error);
  }
};

// Update bed occupancy
export const updateBeds = async (formData, partnerID, onSuccess) => {
  const token = getAuthToken(ROLE_TYPES.slh_manager);
  try {
    const response = await axios.put(
      endpoints.updateBedsOccupancy(partnerID),
      sanitizeForRequest(formData),
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      },
    );

    if (onSuccess) {
      onSuccess(response.data);
    }
    return response.data;
  } catch (error) {
    if (typeof error.response.data === 'string') {
      toast.error(error.response.data);
    }
    toast.error(error.response.data.error);
  }
};

export const releaseSystemBeds = async (partnerID, userID, onSuccess) => {
  const token = getAuthToken(ROLE_TYPES.slh_manager);
  try {
    const response = await axios.put(
      endpoints.releaseSystemClientBed(partnerID, userID),
      sanitizeForRequest({}),
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      },
    );

    if (onSuccess) {
      onSuccess(response.data);
    }
    return response.data;
  } catch (error) {
    if (typeof error.response.data === 'string') {
      toast.error(error.response.data);
    }
    toast.error(error.response.data.error);
  }
};

// Forgot password
export const forgotPassword = async (email, domain) => {
  try {
    const response = await axios.post(
      domain === ROLE_TYPES.client ? endpoints.clientForgotPassword : endpoints.forgotPassword,
      sanitizeForRequest({ email }),
    );

    return response;
  } catch (error) {
    if (typeof error.response.data === 'string') {
      toast.error(error.response.data);
    }
    toast.error(error.response.data.error);
  }
};

// Forgot password
export const resetPassword = async (formData, domain) => {
  try {
    const response = await axios.post(
      domain === ROLE_TYPES.client ? endpoints.clientResetPassword : endpoints.resetPassword,
      sanitizeForRequest(formData),
    );

    return response;
  } catch (error) {
    if (typeof error.response.data === 'string') {
      toast.error(error.response.data);
    }
    toast.error(error.response.data.error);
  }
};

// Verify code
export const verifyCode = async (formData, domain) => {
  try {
    const response = await axios.post(
      domain === ROLE_TYPES.client ? endpoints.clientVerifyCode : endpoints.verifyCode,
      sanitizeForRequest(formData),
    );

    return response;
  } catch (error) {
    if (typeof error.response.data === 'string') {
      toast.error(error.response.data);
    }
    toast.error(error.response.data.error);
  }
};

export const createPF25Admin = async (formData, domain, onSuccess) => {
  const token = getAuthToken(domain);

  try {
    const response = await axios.post(endpoints.createPF25Admin, sanitizeForRequest(formData), {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (onSuccess) {
      onSuccess(response.data);
    }

    return response.data;
  } catch (error) {
    if (!error.response) return;
    if (typeof error.response?.data === 'string') {
      toast.error(error.response.data);
    }
    toast.error(error.response.data.error);
  }
};

export const editPF25Admin = async (formData, domain, managerId, onSuccess) => {
  const token = getAuthToken(domain);

  try {
    const response = await axios.put(
      endpoints.editPF25Admin(managerId),
      sanitizeForRequest(formData),
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      },
    );

    if (onSuccess) {
      onSuccess(response.data);
    }

    return response.data;
  } catch (error) {
    if (!error.response) return;
    if (typeof error.response?.data === 'string') {
      toast.error(error.response.data);
    }
    toast.error(error.response.data.error);
  }
};

export const verifyInvitation = async (code) => {
  try {
    const response = await axios.post(endpoints.verifyInvitation, sanitizeForRequest({ code }));

    return response.data;
  } catch (error) {
    if (typeof error.response?.data === 'string') {
      toast.error(error.response.data);
    }
    toast.error(error.response.data.error);
  }
};

export const activatePFAdmin = async (domain, managerId, onSuccess) => {
  const token = getAuthToken(domain);

  try {
    const response = await axios.post(
      endpoints.activatePF25Admin(managerId),
      sanitizeForRequest({}),
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      },
    );

    if (onSuccess) {
      onSuccess(response.data);
    }

    return response.data;
  } catch (error) {
    if (!error.response) return;
    if (typeof error.response?.data === 'string') {
      toast.error(error.response.data);
    }
    toast.error(error.response.data.error);
  }
};
export const deactivatePFAdmin = async (domain, managerId, onSuccess) => {
  const token = getAuthToken(domain);

  try {
    const response = await axios.post(
      endpoints.deactivatePF25Admin(managerId),
      sanitizeForRequest({}),
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      },
    );

    if (onSuccess) {
      onSuccess(response.data);
    }

    return response.data;
  } catch (error) {
    if (!error.response) return;
    if (typeof error.response?.data === 'string') {
      toast.error(error.response.data);
    }
    toast.error(error.response.data.error);
  }
};
export const resendActivationInvitation = async (domain, adminId, onSuccess) => {
  const token = getAuthToken(domain);

  try {
    const response = await axios.post(
      domain === ROLE_TYPES.admin
        ? endpoints.resendInvitation(adminId)
        : endpoints.resendManagerInvitation(adminId),
      sanitizeForRequest({}),
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      },
    );

    if (onSuccess) {
      onSuccess(response.data);
    }

    return response.data;
  } catch (error) {
    if (!error.response) return;
    if (typeof error.response?.data === 'string') {
      toast.error(error.response.data);
    }
    toast.error(error.response.data.error);
  }
};

export const createSLHManager = async (formData, domain, onSuccess) => {
  const token = getAuthToken(domain);

  try {
    const response = await axios.post(endpoints.createSLHManager, sanitizeForRequest(formData), {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (onSuccess) {
      onSuccess(response.data);
    }

    return response.data;
  } catch (error) {
    if (!error.response) return;
    if (typeof error.response?.data === 'string') {
      toast.error(error.response.data);
    }
    toast.error(error.response.data.error);
  }
};

export const editSLHManager = async (formData, domain, managerId, onSuccess) => {
  const token = getAuthToken(domain);

  try {
    const response = await axios.put(
      endpoints.editSLHManager(managerId),
      sanitizeForRequest(formData),
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      },
    );

    if (onSuccess) {
      onSuccess(response.data);
    }

    return response.data;
  } catch (error) {
    if (!error.response) return;
    if (typeof error.response?.data === 'string') {
      toast.error(error.response.data);
    }
    toast.error(error.response.data.error);
  }
};

export const activateSLHManager = async (domain, managerId, onSuccess) => {
  const token = getAuthToken(domain);

  try {
    const response = await axios.post(
      endpoints.activateSLHManager(managerId),
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      },
    );

    if (onSuccess) {
      onSuccess(response.data);
    }

    return response.data;
  } catch (error) {
    if (!error.response) return;
    if (typeof error.response?.data === 'string') {
      toast.error(error.response.data);
    }
    toast.error(error.response.data.error);
  }
};
export const deactivateSLHManager = async (domain, managerId, onSuccess) => {
  const token = getAuthToken(domain);

  try {
    const response = await axios.post(
      endpoints.deactivateSLHManager(managerId),
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      },
    );

    if (onSuccess) {
      onSuccess(response.data);
    }

    return response.data;
  } catch (error) {
    if (!error.response) return;
    if (typeof error.response?.data === 'string') {
      toast.error(error.response.data);
    }
    toast.error(error.response.data.error);
  }
};

export const assignChildPartner = async (domain, payload, onSuccess) => {
  const token = getAuthToken(domain);

  try {
    await axios.post(endpoints.assignChildPartner, sanitizeForRequest(payload), {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (onSuccess) {
      onSuccess();
    }
  } catch (error) {
    if (!error.response) return;
    if (typeof error.response?.data === 'string') {
      toast.error(error.response.data);
    }
    toast.error(error.response.data.error);
  }
};
